<template>
  <v-container :class="{'v3_index_view':  $vuetify.breakpoint.mdAndUp, 'pa-0': $vuetify.breakpoint.smAndDown}">
    <v-row class="mx-0" :class="{'v3_heading_mobile_view': $vuetify.breakpoint.smAndDown}">
      <v-col cols="8" md="8" class="pt-6 pb-6">
        <v-btn icon @click="$router.go(-1)">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <span class="headline font-weight-light">
          Učenici u školi : {{ school_name }}
        </span>
        <v-breadcrumbs :items="breadcrumbs" style="padding-left: 0; padding-bottom: 0;">
          <template v-slot:divider>
            <v-icon>mdi-chevron-right</v-icon>
          </template>
        </v-breadcrumbs>
      </v-col>
    </v-row>
    <v-row class="mx-0" :class="{'v3_heading_mobile_view': $vuetify.breakpoint.smAndDown}">
      <v-col cols="12" md="4">
        <v-text-field
            outlined
            label="Pretraga"
            v-model="search"
            hide-details
            dense
            prepend-inner-icon="mdi-magnify"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="4">
        <v-autocomplete
            outlined
            :items="school_years"
            hide-details
            label="Odaberi razred..."
            v-model="selected_year"
            dense
            clearable
            @change="getDataTable()"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12">
        <v-data-table
            :headers="headers"
            :items="dataTable"
            :search="search"
            class="elevation-1"
            loading-text="Traženje..."
            :footer-props="{itemsPerPageText: 'Redaka po stranici:'}"
            :header-props="{sortByText: 'Poredaj po'}">
          <template v-slot:[`item.teacher_subjects`]>
            <span style="color: #084776">{{ select_subject_title }}</span>
          </template>
          <template v-slot:no-data>
            <span>
                Za tražene pojmove nema rezultata pretrage.
            </span>
          </template>
          <template v-slot:footer.page-text="items"> Prikazano {{ items.pageStart }} do {{ items.pageStop }} od ukupno
            {{ items.itemsLength }} rezultata
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ApiV2 from "@/services/ApiV2";

export default {
  name: "StudentsInSchool",
  params: {
    school_id: {
      type: Number
    },
    year: {
      type: Number
    }
  },

  data() {
    return {
      breadcrumbs: [
        {text: "Administracija"},
        {text: "Izvještaji"},
        {text: "Broj učenika po školama u županiji"},
        {text: "Učenici u školi"},
      ],
      school_id: this.$route.params.school_id,
      school_name: '',
      selected_year: null,
      school_years: [],
      school_type: '',
      search: '',
      headers: [
        {text: 'Ime', value: 'name'},

        {text: 'Email', value: 'email'},

        {text: 'Odjeljenje', value: 'department_name'}
      ],
      dataTable: [],

    }
  },
  methods: {
    async getDataTable() {
      let params = {
        school_year_id: this.school_year_id,
      };

      if (this.selected_year !== null) {
        params.school_class = this.selected_year;
      }

      let {data} = await ApiV2.get(`reports/students_per_school/${this.school_id}`, {params});
      this.dataTable = data.students;
      this.school_name = data.school_name;
      this.school_type = data.type;
      this.school_years = this.getYears(data.type);
    },
    getYears(school_type) {
      let children = [];
      console.log(school_type);
      if (school_type === "Osnovna škola") {
        children = [
          {
            text: "1. razred",
            value: 1,
          },
          {
            text: "2. razred",
            value: 2,
          },
          {
            text: "3. razred",
            value: 3,
          },
          {
            text: "4. razred",
            value: 4,
          },
          {
            text: "5. razred",
            value: 5,
          },
          {
            text: "6. razred",
            value: 6,
          },
          {
            text: "7. razred",
            value: 7,
          },
          {
            text: "8. razred",
            value: 8,
          },
          {
            text: "9. razred",
            value: 9,
          },
        ];
      } else {
        children = [
          {
            text: "1. razred",
            value: 11,
          },
          {
            text: "2. razred",
            value: 12,
          },
          {
            text: "3. razred",
            value: 13,
          },
          {
            text: "4. razred",
            value: 14,
          },
        ];
      }
      return children;
    },

  },
  mounted() {
    this.school_id = this.$route.query.school;
    this.school_year_id = this.$route.query.year;
    this.getDataTable()
  }

}
</script>

<style scoped>

</style>
